var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "row",
            "align-items": "center"
          },
          on: { click: _vm.closeLot }
        },
        [
          _c("i", {
            staticClass: "p-0 fa fa-pencil-square-o",
            staticStyle: { "margin-right": "8px" }
          }),
          _vm._v("\n    Cerrar\n  ")
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/SystemManagement/cierre-lotes-management/cierre-lotes-list/ActionsCierreLotes.vue?vue&type=template&id=13067412&
// module id = null
// module chunks = 